import caymanasLogo from '../assets/img/caymanasbetLogo.png'
import playaBetsLogo from '../assets/img/playaBets.png'
import monmouthLogo from '../assets/img/monmouthPark-logo-only.png'
import monmouthTicketLogo from '../assets/img/monmouthPark.png'
import guyanaLogo from '../assets/img/GY.png'
import defaultLogo from '../assets/img/TBetMake_Logo-RGB-Hori-noTAG.png'

export const SHOW_PRICE_ACTIVE = {
  caymanas: false
}

export const PRICE_DISPLAY = [
  { venueName: 'monmouth', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true,  platformType: 'win', betType: 'Win'},
  { venueName: 'monmouth', type: 'PLACE_FIXED_ODDS2', display: 'P', apiName: 'up', enable: true, platformType: 'us_place', betType: 'Place', betParams: 5},
  { venueName: 'monmouth', type: 'PLACE_FIXED_ODDS', display: 'S', apiName: 'p', enable: true, platformType: 'place', betType: 'Show', betParams: 8},
  { venueName: 'caymanas', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true, platformType: 'win', betType: 'Win'},
  { venueName: 'caymanas', type: 'PLACE_FIXED_ODDS', display: 'P', apiName: 'p', enable: true, platformType: 'place', betType: 'Place', betParams: 5},
  { venueName: 'caymanas', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
  { venueName: 'MN', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true,  platformType: 'win', betType: 'Win'},
  { venueName: 'MN', type: 'PLACE_FIXED_ODDS2', display: 'P', apiName: 'up', enable: true, platformType: 'us_place', betType: 'Place', betParams: 5},
  { venueName: 'MN', type: 'PLACE_FIXED_ODDS', display: 'S', apiName: 'p', enable: true, platformType: 'place', betType: 'Show', betParams: 8},
  { venueName: 'CAY', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true, platformType: 'win', betType: 'Win'},
  { venueName: 'CAY', type: 'PLACE_FIXED_ODDS', display: 'P', apiName: 'p', enable: true, platformType: 'place', betType: 'Place', betParams: 5},
  { venueName: 'CAY', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
  { venueName: 'PLY', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true, platformType: 'win', betType: 'Win'},
  { venueName: 'PLY', type: 'PLACE_FIXED_ODDS', display: 'P', apiName: 'p', enable: true, platformType: 'place', betType: 'Place'},
  { venueName: 'PLY', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
  { venueName: 'GUY', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
  { venueName: 'GUY', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true, platformType: 'win', betType: 'Win'},
  { venueName: 'GUY', type: 'PLACE_FIXED_ODDS', display: 'P', apiName: 'p', enable: true, platformType: 'place', betType: 'Place'},
  { venueName: 'GUY', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
  { venueName: 'JA', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true, platformType: 'win', betType: 'Win'},
  { venueName: 'JA', type: 'PLACE_FIXED_ODDS', display: 'P', apiName: 'p', enable: true, platformType: 'place', betType: 'Place'},
  { venueName: 'JA', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
  { venueName: 'PWD', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true,  platformType: 'win', betType: 'Win'},
  { venueName: 'PWD', type: 'PLACE_FIXED_ODDS2', display: 'P', apiName: 'up', enable: true, platformType: 'us_place', betType: 'Place', betParams: 5},
  { venueName: 'PWD', type: 'PLACE_FIXED_ODDS', display: 'S', apiName: 'p', enable: true, platformType: 'place', betType: 'Show', betParams: 8},
  { venueName: 'NGTJA', type: 'WIN_FIXED_ODDS', display: 'W', apiName: 'w', enable: true, platformType: 'win', betType: 'Win'},
  { venueName: 'NGTJA', type: 'PLACE_FIXED_ODDS', display: 'P', apiName: 'p', enable: true, platformType: 'place', betType: 'Place'},
  { venueName: 'NGTJA', type: 'PLACE_FIXED_ODDS2', display: 'S', apiName: 's', enable: false, platformType: '', betType: ''},
]

export const NAMINGS = [
  { venueName: 'monmouth', word: 'Stake', replaceWith: 'Cost'},
  { venueName: 'monmouth', word: 'paid', replaceWith: 'Win'},
  { venueName: 'monmouth', word: 'unresulted', replaceWith: 'Results not in'},
  { venueName: 'monmouth', word: 'ABANDONED', replaceWith: 'CANCELLED'},
  { venueName: 'monmouth', word: 'No Win', replaceWith: 'Not a Winner'},
  { venueName: 'MN', word: 'Stake', replaceWith: 'Cost'},
  { venueName: 'MN', word: 'paid', replaceWith: 'Win'},
  { venueName: 'MN', word: 'unresulted', replaceWith: 'Results not in'},
  { venueName: 'MN', word: 'ABANDONED', replaceWith: 'CANCELLED'},
  { venueName: 'MN', word: 'No Win', replaceWith: 'Not a Winner'},
  { venueName: 'CAY', word: 'Cash Position', replaceWith: 'Teller Report'},
  { venueName: 'CAY', word: 'Refund', replaceWith: 'Cancel Bet'},
  { venueName: 'JA', word: 'Cash Position', replaceWith: 'Teller Report'},
  { venueName: 'JA', word: 'Refund', replaceWith: 'Cancel Bet'},
  { venueName: 'PWD', word: 'Stake', replaceWith: 'Cost'},
  { venueName: 'PWD', word: 'paid', replaceWith: 'Win'},
  { venueName: 'PWD', word: 'unresulted', replaceWith: 'Results not in'},
  { venueName: 'PWD', word: 'ABANDONED', replaceWith: 'CANCELLED'},
  { venueName: 'PWD', word: 'No Win', replaceWith: 'Not a Winner'},
  { venueName: 'NGTJA', word: 'Cash Position', replaceWith: 'Teller Report'},
  { venueName: 'NGTJA', word: 'Refund', replaceWith: 'Cancel Bet'},
]

export const HIGHKEYBOARD = {
  MN: false,
  CAY: true,
  caymanas: true,
  JA: false,
  PWD: false,
  NGTJA: true,
}
export const PRINTERTYPE = {
  MN: 'rt',
  monmouth: 'rt',
  CAY: 'posiflex',
  JA: 'posiflex',
  PWD: 'rt',
  NGTJA:'rt'
}

export const PRINTLARGER = {
  MN: false,
  CAY: true,
  caymanas: true,
  JA: true,
  PWD: true,
  NGTJA: true
}

export const PRINTRECIEPTS = {
  MN: false,
  CAY: true,
  caymanas: true,
  JA: true,
  PWD: true,
  NGTJA: true
}

export const REPRINTAVAILABLE = {
  MN: false,
  CAY: true,
  caymanas: true,
  JA: true,
  PWD: true,
  NGTJA: true
}

export const CALLATTENTDANT = {
  MN: false,
  CAY: false,
  caymanas: false,
  JA: true,
  PWD: true,
  NGTJA: true
}

export const WPSAVAILABLE = {
  MN: true,
  CAY: true,
  caymanas: true,
  JA: true,
  PWD: true,
  NGTJA: true
}

export const SESSIONTIMEOUT = {
  MN: 3600000,
  CAY: 60000,
  cayamanas: 60000,
  JA: 3600000,
  PWD: 3600000,
  NGTJA: 3600000
}

export const PLAYERCARDACTIVE = {
  MN: true,
  monmouth: true,
  PWD: true
}

export const logo = {
  caymanas: caymanasLogo,
  CAY: caymanasLogo,
  PLY: playaBetsLogo,
  playabets: playaBetsLogo,
  monmouth: monmouthLogo,
  MN: monmouthLogo,
  GUY: guyanaLogo,
  JA: defaultLogo,
  PWD: defaultLogo,
  NGTJA: defaultLogo,
}

export const ticketLogo = {
  caymanas: caymanasLogo,
  CAY: caymanasLogo,
  PLY: playaBetsLogo,
  playabets: playaBetsLogo,
  monmouth: monmouthTicketLogo,
  MN: monmouthTicketLogo,
  GUY: guyanaLogo,
  JA: defaultLogo,
  PWD: defaultLogo,
  NGTJA: defaultLogo,
}

export const VENUENAME = {
  CAY: 'Caymanas Park',
  PLY: 'PlayaBets',
  MN: 'Monmouth Park',
  GUY: 'Guyana',
  JA: 'JA Venue',
  PWD: 'PWD Venue',
  NGTJA: 'NGTJA Venue',
}


export const adjType = {
  'BET_CASH_IN' : 'Bet Cash in',
  'BET_PAYOUT' : 'Bet Pay out',
  'REFUND' : 'Payout Win Bet',
  'FLOAT_ADJUSTMENT' : 'Float Adjustment',
  'BET_CANCELLED' : 'Refunded & Cancelled bet',
  'BET_REFUNDED' : 'Refunded & Cancelled bet',
  'VOUCHER_REDEEMED':'Voucher Redeemed',
  'VOUCHER_ISSUED' : 'Voucher Created',
  'CLIENT_DEPOSIT' : 'Customer Deposit',
  'BET_REJECTED' : 'Rejected & Refunded bet',
  'CLIENT_WITHDRAWAL' : 'Customer Withdrawal',
}

export const HELPBTNON = {
  CAY: true,
  JA: true,
  NGTJA: true,
}

export const MULTIREDEMPTIONAVAILABLE = {
  MN: true,
  CAY: true,
  caymanas: true,
  JA: true,
  PWD: true,
  NGTJA: true,
}

export const USERROLE = {
  ENDUSER: 0,
  ADMIN: 1
}

export const NETWORKSTATUS = {
  CAY : true,
  NGTJA: true,
  JA: true
}

export const ACCOUNTDEP = {
  CAY : true,
  MN: false,
  JA: true,
  GUY: true
}

export const FUND_OP_TYPE = {
  NONE: 'NONE',
  DEPOSIT: 'Deposit',
  WITHDRAW: 'Withdraw',
}